import {
  ApiEnvironment,
  getBasePath,
  getCorsConfiguration,
} from './environment'
import { CheckPeriod } from '../types/tink.interface'

interface InitializeRequest {
  clientUuid?: string
  origin: string
  personId?: string
  traversalUuid?: string
  loanLeadUuid?: string
  applicationUuid?: string
  customerUuid?: string
  checkPeriodDays: CheckPeriod
  firstName?: string
  lastName?: string
  iban?: string
}

interface SuccessRequest {
  clientUuid?: string
  origin: string
  personId?: string
  transactionId: string
  traversalUuid?: string
  loanLeadUuid?: string
  applicationUuid?: string
  customerUuid?: string
}

export interface InitializeResponse {
  result: {
    // eslint-disable-next-line camelcase
    wizard_session_key: string
    // eslint-disable-next-line camelcase
    transaction_id: string
  }
}

export const wizardInitialize = async (
  environment: ApiEnvironment,
  request: InitializeRequest,
): Promise<InitializeResponse> => {
  const response = await fetch(
    `${getBasePath(environment)}/v1/wizard/initialize`,
    {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
      ...getCorsConfiguration(environment),
    },
  )
  if (!response.ok) {
    throw new Error('Failed to initialize wizard')
  }
  return response.json()
}

export const wizardSuccess = async (
  environment: ApiEnvironment,
  request: SuccessRequest,
): Promise<void> => {
  await fetch(`${getBasePath(environment)}/v1/wizard/success`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(request),
    ...getCorsConfiguration(environment),
  }).catch((error) => {
    // Given that the package does not provide a clear error handling/logging strategy, for now it just logs
    // eslint-disable-next-line no-console
    console.error(error)
  })
}
